<template>
    <el-dialog class="el-dialogs" :title="title" width="600px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="120px">
            <el-form-item label="授权账号：" prop="accreditUser">
                <el-select v-model="searchForm.accreditUser" style="width: 100%" clearable placeholder="请选择授权账号">
                    <el-option
                            v-for="item in mageTypeList"
                            :key="item.id"
                            :label="item.mobilePhone"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="授权登录IP：" prop="accreditIp">
                <el-input
                        type="textarea"
                        placeholder="请输入IP地址，多个用英文逗号隔开(限500字)"
                        maxlength="500"
                        rows="4" resize="none"
                        v-model.trim="searchForm.accreditIp">
                </el-input>
            </el-form-item>
            <el-form-item label="授权时间：" prop="authorizationTime">
                <el-date-picker
                        v-model="searchForm.authorizationTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="授权原因：" prop="accreditReason">
                <el-input
                        type="textarea"
                        placeholder="请输入授权原因(限100字)"
                        maxlength="100"
                        rows="2" resize="none"
                        v-model.trim="searchForm.accreditReason">
                </el-input>
            </el-form-item>
            <el-form-item label="状态" prop="accreditStatus">
                <el-switch
                        v-model="searchForm.accreditStatus"
                        active-value="0"
                        inactive-value="1">
                </el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addAuthorize",
    data() {
        return {
            title: '新增授权',
            visible: false,
            seleData: {},
            searchForm: {
                id: '',
                accreditUser: '',
                accreditIp: '',
                authorizationTime: [],
                accreditBeginDate: '',
                accreditEndDate: '',
                accreditReason: '',
                accreditStatus: '0',
            },
            rules: {
                accreditUser: [
                    {required: true, message: '请选择授权账号', trigger: 'change'}
                ],
                accreditIp: [
                    {required: true, message: '请输入授权登录IP', trigger: 'blur'}
                ],
                authorizationTime: [
                    {type: 'array', required: true, message: '请选择授权时间', trigger: 'change'}
                ],
            },
            mageTypeList: [],
        }
    },

    methods: {
        init(setName, row) {
            this.seleData = {}
            this.searchForm.id = ''
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            this.getOtherData()
            if (row) {
                this.title = '编辑授权'
                this.seleData = row
                this.getDatail()
            } else {
                this.title = '新增授权'
            }
        },

        getOtherData() {
            this.$axios(this.api.user.sysuserSelectAllUserAccount).then(data => {
                if (data && data.status) {
                    this.mageTypeList = data.data
                }
            })
        },

        getDatail() {
            this.$axios(this.api.user.sysUserAccreditGetById + this.seleData.id, {}).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key=>{
                        this.searchForm[key] = data.data[key]
                    })
                    this.searchForm.authorizationTime = []
                    if (this.searchForm.accreditBeginDate){
                        this.searchForm.authorizationTime.push(this.searchForm.accreditBeginDate)
                        this.searchForm.authorizationTime.push(this.searchForm.accreditEndDate)
                    }
                }
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.authorizationTime && this.searchForm.authorizationTime.length==2){
                        this.searchForm.accreditBeginDate = this.searchForm.authorizationTime[0]
                        this.searchForm.accreditEndDate = this.searchForm.authorizationTime[1]
                    }
                    if (this.seleData.id) {
                        this.$axios(this.api.user.sysUserAccreditUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.user.sysUserAccreditSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>